import { Event } from "../events/Event";
import { EventDispatcher } from "../events/EventDispatcher";
export class Filter extends EventDispatcher {
    onChange() {
        this.event(Event.CHANGED);
    }
}
